import { ProtectedRoute } from "@/lib/auth/protected-route"
import { Roles } from "@/lib/team/roles"
import { FullEstimateWizard } from "@/components/estimates/full-estimate/wizard"
import { EstimatePrerequisiteGate } from "@/components/estimates/estimate-prerequisite-gate"
import { useLocation } from "react-router"

// Full Estimate — /estimates/full.
// New design: QE3 inputs (Vehicle / Photos / Tags) → Generate
// (animated processing) → Edit (line items) → Review.
// Legacy implementation lives at /estimates/full-legacy.

export default function FullEstimatePage() {
  const location = useLocation()

  return (
    <ProtectedRoute
      allowedRoles={[
        Roles.ServiceAdvisor,
        Roles.Estimator,
        Roles.Director,
        Roles.GeneralManager,
        Roles.ServiceManager,
      ]}
    >
      <EstimatePrerequisiteGate>
        <FullEstimateWizard key={location.key} />
      </EstimatePrerequisiteGate>
    </ProtectedRoute>
  )
}
